import { BluePill } from '../../DropdownEditor/CustomOptions';
import React from 'react';
import { IFormatterProps } from '../../../@types/workspaceTypes';
import { INominalTransaction, Involves } from '../../../graphql/schema/p4types';

const CustomerOrSupplierFormatter = (props: IFormatterProps<INominalTransaction, string | null>) => {
  const { dependentValues } = props;
  if (!dependentValues || !dependentValues.options || !dependentValues.rowData) return <div />;
  const { rowData } = dependentValues;

  const findEnum = (record: { value: Involves }): boolean => {
    const { supplier, customer } = dependentValues.rowData;
    const involvesCustomer = customer ? Involves.Customer : null;
    const involvesSupplier = supplier ? Involves.Supplier : null;
    return record.value === (involvesCustomer || involvesSupplier);
  };

  const { options } = dependentValues;
  let value: { label?: string };
  if (options.enumValues) {
    value = options.enumValues.find(findEnum);
  } else {
    value = options.find(findEnum);
  }

  if (value?.label) {
    const label = value.label;
    const { customerOrSupplierName } = rowData;
    if (customerOrSupplierName !== null) {
      return (
        <div title={customerOrSupplierName}>
          {customerOrSupplierName}
          <BluePill style={{ float: 'right' }}>{label}</BluePill>
        </div>
      );
    }
  }
  return <div />;
};

export default CustomerOrSupplierFormatter;
